// extracted by mini-css-extract-plugin
module.exports = {"container":"Teammate_container__3_rUB","name":"Teammate_name__3AVwM","removeButton":"Teammate_removeButton__iUx8C"};